var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ra-page--section"},[_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('auth-x-form',{attrs:{"action":"edit"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }